<template>
    <div class="card mb-3">
        <div class="card-header">
            <b>{{ title }}</b>
        </div>
        <div class="card-body">
            <p class="text-muted small">{{ description }}</p>

            <div class="mb-2">
                <button type="button" class="btn btn-outline-primary" @click.prevent="onDownloadTemplate()">
                    <i class="fal fa-download"></i> Download Template
                </button>
                <label class="btn btn-outline-primary mb-0 ml-2">
                    <i class="fal fa-upload"></i> {{ report && !report.ok ? 'Upload Corrected File' : 'Upload File' }}
                    <input type="file" accept=".xlsx" hidden @change="onFileSelected">
                </label>
            </div>

            <label v-if="kind == 'priors'" class="small font-weight-normal d-block">
                <input type="checkbox" v-model="allowNetPayMismatch">
                Import paystubs whose net pay doesn't reconcile (as warnings)
            </label>

            <form-errors :errors="formErrors" />

            <import-report-panel v-if="report" :report="report" :file-name="file.name" />

            <button v-if="canImport" type="button" class="btn btn-primary" @click.prevent="onImport()">
                Import {{ title }}
            </button>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import ImportReportPanel from './ImportReportPanel'

export default {
    components: {ImportReportPanel, },
    props: ['client', 'company', 'keyField', 'kind', 'title', 'description', ],
    data() {
        return {
            file: null,
            report: null,
            formErrors: [],
            allowNetPayMismatch: false,
        }
    },
    computed: {
        canImport() {
            return this.report && this.report.ok && this.report.dry_run
        },
        imported() {
            return this.report && this.report.ok && !this.report.dry_run
        },
        baseURL() {
            return `/clients/${this.client.id}/settings/companies/${this.company.id}`
        },
    },
    watch: {
        allowNetPayMismatch() {
            // the validation result depends on it, so an earlier one no longer applies
            if (this.file && !this.imported) {
                this.submit(true)
            }
        },
    },
    methods: {
        onDownloadTemplate() {
            api.redirect(`${this.baseURL}/import-templates/${this.kind}?key_field=${this.keyField}`)
        },
        onFileSelected(evt) {
            const file = evt.target.files[0]
            // clear it so choosing the same file again, once corrected, still fires a change
            evt.target.value = ''
            if (!file) {
                return
            }
            this.file = file
            this.submit(true)
        },
        onImport() {
            const summary = this.report.summary.join('\n')
            if (!window.confirm(`Import ${this.file.name} into ${this.company.company_code} - ${this.company.name}?\n\n${summary}`)) {
                return
            }
            this.submit(false)
        },
        submit(dryRun) {
            this.formErrors = []
            this.report = null
            this.$store.dispatch('START_LOADING')
            api.upload(`${this.baseURL}/imports/${this.kind}`, this.file, {
                fieldName: 'file',
                formData: {
                    key_field: this.keyField,
                    dry_run: dryRun ? 'true' : 'false',
                    allow_net_pay_mismatch: this.allowNetPayMismatch ? 'true' : 'false',
                },
            }).then((resp) => {
                this.$store.dispatch('STOP_LOADING')
                this.report = resp
                if (!dryRun && resp.ok) {
                    this.$bus.showInfo(`${this.title} imported.`)
                }
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.formErrors = errors.__all__
            })
        },
    },
}
</script>
